// Persistencia de borradores de formularios largos (registro de emprendedor)
// en localStorage, para que un cierre accidental (boton atras, click fuera
// del modal, cerrar la pestana) no haga perder lo ya llenado.
//
// No se guardan archivos (fotos de negocios): un File/Blob no sobrevive a
// JSON.stringify ni a un refresco de pagina, asi que se descartan al guardar
// y el usuario simplemente vuelve a adjuntarlos si hace falta.

const PREFIX = 'sitre_draft_';

export function saveDraft(key, data) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(data));
  } catch {
    // localStorage lleno o deshabilitado (modo privado, etc.): no bloquea el formulario.
  }
}

export function loadDraft(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearDraft(key) {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    // no-op
  }
}

// Quita el campo `fotos` (File/blob URL, no serializable) de cada negocio
// antes de guardar el borrador.
export function stripFotosNegocios(negocios) {
  if (!Array.isArray(negocios)) return negocios;
  return negocios.map(({ fotos, ...resto }) => resto);
}
